const initialState = {
  loading: false,
  error: null,
  userDetails: null,
  dashboardData: null,
  employerdashboardData: null,
  onboardForm:null,
  accessToken: null,
  refreshToken: null,
  userId: null,
  permissions: []
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_REQUEST":
      return { ...initialState,...state, loading: true, error: null };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        accessToken: action.payload.access,
        refreshToken: action.payload.refresh,
        userId: action.payload.user_id,
        permissions: action.payload.permissions || []
      };
    case "LOGIN_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "GET_USER_DETAILS_SUCCESS":
      return {
        ...state,
        loading: false,
        userDetails: action.payload.data
      };
    case "GET_USER_DETAILS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case "GET_DASHBOARD_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        dashboardData: action.payload
      };
    case "GET_DASHBOARD_DATA_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case "GET_EMPLOYER_DASHBOARD_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        employerdashboardData: action.payload
      };
    case "GET_EMPLOYER_DASHBOARD_DATA_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case "LOGOUT":
      return {
        ...initialState
      };
    case "GET_USER_PERMISSION_SUCCESS":
      return {
        ...state,
        loading: false,
        permissions: action.payload.permissions || []
      };
    case "GET_USER_PERMISSION_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case "ADD_FORM_DATA_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_FORM_DATA_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    default:
      return state;
  }
};

export default AuthReducer;
